import { ApiAddress } from "@/services/apis"
import request from "@/services/request"
import { PropertySetModule } from "./modal"

export async function getPropertySets(): Promise<PropertySetModule.Modal[]> {
  return await request.get(ApiAddress.PROPERTY_SETS)
}

export async function duplicatePropertySet(id: number) {
  const setData = await getPropertySet(id)
  const body = {
    name: `${setData.name} copy`,
    components: setData.components.map(item => item.id),
    fugModel: setData.fugModel,
    reactions: setData.reactions.map(item => {
      const newReaction: any = {...item}
      delete newReaction.id
      return newReaction
    }),
  }
  return request.post(ApiAddress.PROPERTY_SETS, body)
}

export function getPropertySet(id: number): Promise<PropertySetModule.Modal> {
  return request.get(ApiAddress.PROPERTY_SET, {params: {id}})
}

export function createPropertySet(body): Promise<PropertySetModule.Modal> {
  return request.post(ApiAddress.PROPERTY_SETS, body)
}

export function updatePropertySet(id, body): Promise<PropertySetModule.Modal> {
  return request.put(ApiAddress.PROPERTY_SET, body, { params: {id} })
}

export function removePropertySet(id: number): Promise<null> {
  return request.delete(ApiAddress.PROPERTY_SET, { params: { id } })
}

export function createPropertySetReactions(body, params) {
  return request.post(ApiAddress.PROPERTY_SET_REACTIONS, body, { params })
}

export function getPropertySetReactions(params): Promise<PropertySetModule.Reaction[]> {
  return request.get(ApiAddress.PROPERTY_SET_REACTIONS, { params })
}

export function updatePropertySetReactions(body, params) {
  return request.put(ApiAddress.PROPERTY_SET_REACTION, body, { params })
}

export function deletePropertySetReactions(params) {
  return request.delete(ApiAddress.PROPERTY_SET_REACTION, { params })
}


export function createReactionSet(body, params) {
  return request.post(ApiAddress.REACTION_SETS, body, { params })
}

export function updateReactionSet(body, params) {
  return request.put(ApiAddress.REACTION_SET, body, { params })
}

export function deleteReactionSet(params) {
  return request.delete(ApiAddress.REACTION_SET, { params })
}


export function generateSetJson(params) {
  return request.put(ApiAddress.PROPERTY_SET_JSON, {}, { params })
}

export function updateSetJson(body, params) {
  return request.put(ApiAddress.UPDATE_SET_JSON, body, { params })
}

export const OrganizationPropertySetService = {
  getPropertySets: (orgId: number): Promise<PropertySetModule.Modal[]> => {
    return request.get(ApiAddress.ORGANIZATION_PROPERTY_SETS, { params: { orgId } })
  },
  getPropertySet: (id: number): Promise<PropertySetModule.Modal> => {
    return request.get(ApiAddress.ORGANIZATION_PROPERTY_SET, { params: { id } })
  },
  createPropertySet: (orgId: number, body): Promise<PropertySetModule.Modal> => {
    return request.post(ApiAddress.ORGANIZATION_PROPERTY_SETS, body, { params: { orgId } })
  },
  updatePropertySet: (id: number, body): Promise<PropertySetModule.Modal> => {
    return request.put(ApiAddress.ORGANIZATION_PROPERTY_SET, body, { params: { id } })
  },
  removePropertySet: (id: number): Promise<null> => {
    return request.delete(ApiAddress.ORGANIZATION_PROPERTY_SET, { params: { id } })
  },
  duplicatePropertySet: async (orgId: number, id: number) => {
    const setData = await OrganizationPropertySetService.getPropertySet(id)
    const body = {
      name: `${setData.name} copy`,
      components: setData.components.map(item => item.id),
      fugModel: setData.fugModel,
      reactions: setData.reactions.map(item => {
        const newReaction: any = {...item}
        delete newReaction.id
        return newReaction
      }),
    }
    return request.post(ApiAddress.ORGANIZATION_PROPERTY_SETS, body, { params: { orgId } })
  },
  createPropertySetReactions: (orgId: number, body, params) => {
    return request.post(ApiAddress.ORGANIZATION_PROPERTY_SET_REACTIONS, body, { params: { orgId, ...params } })
  },
  getPropertySetReactions: (orgId: number, params): Promise<PropertySetModule.Reaction[]> => {
    return request.get(ApiAddress.ORGANIZATION_PROPERTY_SET_REACTIONS, { params: { orgId, ...params } })
  },
  updatePropertySetReactions: (orgId: number, body, params) => {
    return request.put(ApiAddress.ORGANIZATION_PROPERTY_SET_REACTION, body, { params: { orgId, ...params } })
  },
  deletePropertySetReactions: (orgId: number, params) => {
    return request.delete(ApiAddress.ORGANIZATION_PROPERTY_SET_REACTION, { params: { orgId, ...params } })
  },
  createReactionSet: (orgId: number, body, params) => {
    return request.post(ApiAddress.ORGANIZATION_REACTION_SETS, body, { params: { orgId, ...params } })
  },
  updateReactionSet: (orgId: number, body, params) => {
    return request.put(ApiAddress.ORGANIZATION_REACTION_SET, body, { params: { orgId, ...params } })
  },
  deleteReactionSet: (orgId: number, params) => {
    return request.delete(ApiAddress.ORGANIZATION_REACTION_SET, { params: { orgId, ...params } })
  },
  generateSetJson: (orgId: number, params) => {
    return request.put(ApiAddress.ORGANIZATION_PROPERTY_SET_JSON, {}, { params: { orgId, ...params } })
  },
  updateSetJson: (orgId: number, body, params) => {
    return request.put(ApiAddress.ORGANIZATION_UPDATE_SET_JSON, body, { params: { orgId, ...params } })
  }
}
